// extracted by mini-css-extract-plugin
module.exports = {"header":"quiz-header_header__24zrd","steps":"quiz-header_steps__2l0us","step":"quiz-header_step__2lOvi","icon":"quiz-header_icon__1-7u7"};